import { render, staticRenderFns } from "./commissioned-manage.vue?vue&type=template&id=3b24754a"
import script from "./commissioned-manage.vue?vue&type=script&lang=ts"
export * from "./commissioned-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports